import styled from 'styled-components';
import media from 'src/styles/Media.styled';
import Grid from '@material-ui/core/Grid';

export const AccountDetailsContainer = styled.div`
    display: block;
    width: 100%;
    height: calc(100% - 60px);
    position: relative;
    overflow-y: scroll;
    overflow-x: hidden;
    -webkit-overflow-scrolling: touch;
    ${media.smalDevice`
   height: calc(100% - 113px);
    `}
    ${media.mobileDevice`
        height: 100vh;
    `}
`;

export const AccountDetailsBody = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    padding: 1rem 1rem 0 1rem;
    ${media.mobileDevice`
        padding:  1rem 1rem 0 1rem;
    `}
`;

export const AccountDetailsTabs = styled.div`
    display: flex;
    width: 100%;
    box-sizing: border-box;

    ${media.mobileDevice`
        margin-bottom : 2%;
    `}
`;

export const AccountDetailTabBody = styled.div`
    display: flex;
    flex-direction: column;
    width: 99%;
    margin: 0 auto;
`;
export const AccountDetailBodyContainer = styled.div`
    flex-grow: 1;
    overflow-y: scroll;
    margin-top: 5px;
    padding-right: 10px;
    box-sizing: border-box;
    &::-webkit-scrollbar {
        display: block;
        width: 5px;
    }

    &::-webkit-scrollbar-thumb {
        background: #888;
        border-radius: 10px;
        height: 12rem;
    }
    &::-webkit-scrollbar-thumb:hover {
        background: #555;
    }

    ${media.mobileDevice`
        &::-webkit-scrollbar {
            display: none;
        }
        padding-bottom: 175px;
        padding-right: 0;
    `}
`;

export const AccountDetailsGridContainer = styled(Grid)`
    width: 100%;
    min-height: 78px;
    background: #ffffff;
    box-shadow: 0px 0px 6px #00000029;
    border-radius: 6px;
    opacity: 1;
    margin: 10px 0 -15px 0;
    padding-right: 10px;
    ${media.mobileDevice`
  padding-bottom:6px;
 box-shadow: none;
    `}
`;

export const AccountDetailsGrid = styled(Grid)`
    text-align: left;
    letter-spacing: 0px;
    color: #202124;
    opacity: 1;
    padding: 1rem 1rem 1rem 1rem;

    ${media.mobileDevice`
        padding:  1rem 1rem 1rem 1rem;
    `}
`;

export const AccountDetailsFont = styled.p`
    font-family: ${({ isRegular, isDemi, isItalic }) =>
        isRegular
            ? 'AvenirNextWorld Regular'
            : isDemi
            ? 'AvenirNextWorld Demi'
            : isItalic && 'AvenirNextWorld italic'};
    margin-top: 7px;
    line-height: 1.4;
    min-height: 20px;
    font-size: ${({ isDemi }) => (isDemi ? '14px' : '15px')};
    color: ${({ isRegular, isDemi }) =>
        isRegular ? '#202124' : isDemi && '#202124'};
    ${media.mobileDevice`
        font-size: ${({ isDemi }) => (isDemi ? '14px' : '15px')};
    `}
`;

export const AccountDetailsPhoneFont = styled.p`
    font-family: 'AvenirNextWorld Regular';
    margin-top: 7px;
    line-height: 1.4;
    min-height: 20px;
    font-size: 15px;
    color:#202124;
    ${media.mobileDevice`
    font-family: 'AvenirNextWorld Demi';
    `}
`;

export const AccountDetailsTopTitle = styled.p`
    font-family: 'AvenirNextWorld Demi';
    font-size: 14px;
    margin-bottom: -5px;
    color: #202124;
    text-align: left;
    letter-spacing: 0px;
    color: #202124;
    opacity: 1;
    ${media.mobileDevice`
    margin-top:-9px;      `}
`;

export const SalesStructureHeader = styled.p`
    font-family: ${({ isRegular, isDemi, isItalic }) =>
        isRegular
            ? 'AvenirNextWorld Regular'
            : isDemi
            ? 'AvenirNextWorld Demi'
            : isItalic && 'AvenirNextWorld italic'};
    font-size: ${({ isDemi }) => (isDemi ? '14px' : '15px')};
    color: ${({ isRegular, isDemi }) =>
        isRegular ? '#140F4B' : isDemi && '#202124'};
    margin-bottom: -10px;
    margin-top: 1px;
    ${media.mobileDevice`
        font-size: ${({ isDemi }) => (isDemi ? '14px' : '15px')};
    `}
`;

export const AccountDetailsTitle = styled.p`
    font-family: 'AvenirNextWorld Demi';
    font-size: 14px;
    margin-bottom: -5px;
    color: #202124;
    text-align: left;
    letter-spacing: 0px;
    color: #202124;
    opacity: 1;
`;

export const AccountDetailFirstCardFont = styled.span`
    font-family: ${({ isRegular, isDemi, isItalic }) =>
        isRegular
            ? 'AvenirNextWorld Regular'
            : isDemi
            ? 'AvenirNextWorld Demi'
            : isItalic && 'AvenirNextWorld italic'};
    font-size: ${({ isDemi }) => (isDemi ? '13px' : '13px')};
    color: ${({ isRegular, isDemi }) =>
        isRegular ? '#140F4B' : isDemi && '#202124'};
    ${media.mobileDevice`
        font-size: ${({ isDemi }) => (isDemi ? '13px' : '13px')};
    `}
`;
export const DetailsTabs = styled.div`
    display: flex;
    width: 100%;
    box-sizing: border-box;
    margin: 23px 0 -12px 0;
    ${media.mediumDevice`
   margin:23px 0 0 0;
`}
    ${media.mobileDevice`
    margin-bottom: 0px;
`}
`;

export const OrderDetailTabBodyContainer = styled.div`
    flex-grow: 1;
    box-sizing: border-box;
    &::-webkit-scrollbar {
        display: block;
        width: 5px;
    }

    &::-webkit-scrollbar-thumb {
        background: #888;
        border-radius: 10px;
        height: 12rem;
    }
    &::-webkit-scrollbar-thumb:hover {
        background: #555;
    }

    ${media.mobileDevice`
        &::-webkit-scrollbar {
            display: none;
        }
        margin-top: 15px;
        padding-bottom: 200px;
        overflow-y: scroll;
    `}
`;

export const OrderDetailTabBody = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    padding: 0 5px 0 2px;
    overflow-y: scroll;
    height: 90%;
    ${media.mobileDevice`
    height: auto;
    padding-right: 3px;
    background: #ffffff;
    box-shadow: 0px 0px 6px #00000029;
    border-radius: 6px;
    `}
`;
export const FavoriteIconMobileContainer = styled.span`
    display: none;
    ${media.smalDevice`
    display:none;
    `};
    ${media.mobileDevice`
    background: #ffffff;
    box-shadow: 0px 0px 2px #00000029;
    border: 1px solid #ebebeb;
    border-radius: 6px;
    opacity: 1;
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: ${({ marginRight }) => marginRight};
`};
`;

export const FavoriteIconDesktopContainer = styled.div`
    ${media.mobileDevice`
    display: none;
`};
`;

export const BottomNavigationButtonContainer = styled.div`
    display: flex;
    width: 100%;
    max-width: 1096px;
    flex-direction: row;
    box-shadow: 0px -3px 6px #00000014;
    position: absolute;
    right: 0;
    bottom: 0;
    background-color: white;
    justify-content: ${(props) =>
        props.justifyContent ? props.justifyContent : 'flex-end'};
    padding: ${(props) => (props.padding ? props.padding : '0px')};
    @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait) {
        /* For portrait layouts only */
        justify-content: ${({ smallJustifyContent }) =>
            smallJustifyContent ? smallJustifyContent : 'flex-end'};
        padding-right: 0px;
        padding: ${(props) => (props.mbPadding ? props.mbPadding : '0px')};
    }
    ${media.mobileDevice`
         justify-content: space-evenly;
         
          padding: ${(props) => (props.mbPadding ? props.mbPadding : '0px')}; `}
`;
export const TextBold = styled.div`
    text-align: left;
    font-family: AvenirNextWorld demi;
    color: ${(props) => props.color};
    letter-spacing: -0.12px;
    display: flex;
    align-self: center;
    margin: 0;
    padding: 0;
`;
export const RadioAlign = styled.div`
    display: flex;

    font-family: ${({ isRegular, isDemi, isItalic }) =>
        isRegular
            ? 'AvenirNextWorld Regular'
            : isDemi
            ? 'AvenirNextWorld Demi'
            : isItalic && 'AvenirNextWorld italic'};
    font-size: ${({ isDemi }) => (isDemi ? '14px' : '15px')};
    color: ${({ isRegular, isDemi }) =>
        isRegular ? '#140F4B' : isDemi && '#202124'};
    margin-bottom: 0px;
    padding-top: 10px;
    ${media.mobileDevice`
    font-size: ${({ isDemi }) => (isDemi ? '14px' : '15px')};
`}
`;

export const BacktoAccountLink = styled.div`
    text-align: left;
    font-family: 'AvenirNextWorld Regular';
    font-size: 16px;
    letter-spacing: 0px;
    color: #1010eb;
    opacity: 1;
`;
